var _path, _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgQuestionAnswered(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.79 2.102c-5.565 0-10.06 4.504-10.06 10.08l.002.254c.051 1.95.686 3.888 1.814 5.532l.012.014.003.031-1.85 4.368 4.404-1.872-.101-.068c1.744 1.201 3.679 1.82 5.776 1.82 5.565 0 10.06-4.504 10.06-10.08 0-5.575-4.495-10.08-10.06-10.08z",
    fill: `url(#${_id})`
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.829 17.485l7.07-7.071L17.485 9l-5.656 5.657-2.83-2.829-1.413 1.414 4.243 4.243z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 12.586,
    y1: 15.881,
    x2: 11.676,
    y2: 17.314,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  })))));
}
export default SvgQuestionAnswered;